import * as rootypes from './mutations_type';

export const state = {
  isShowMobileMenu: false,
  pageLoadingStatus: false,
  isShowPopup: false,
  isPopupType: '',
};

export const getters = {
  getPopupType: s => s.isPopupType,
  getPopupStatus: s => s.isShowPopup,
  mobileMenuStatus: s => s.isShowMobileMenu,
  rootState: s => s,
  pageLoadingStatus: s => s.pageLoadingStatus,
};

export const actions = {
  changePopupType({ commit }, type) {
    commit(rootypes.popupType, type);
  },
  toggleMobileMenuStatus({ commit }) {
    commit(rootypes.toggleMobileMenu);
  },
  togglePopupStatus({ commit }) {
    commit(rootypes.togglePopup);
  },
  showLoading({ commit }) {
    commit(rootypes.loadingStatusShow);
  },
  hideLoading({ commit }) {
    commit(rootypes.loadingStatusHide);
  },
};

export const mutations = {
  [rootypes.popupType](s, type) {
    s.isPopupType = type;
  },
  [rootypes.togglePopup](s) {
    s.isShowPopup = !s.isShowPopup;
  },
  [rootypes.toggleMobileMenu](s) {
    s.isShowMobileMenu = !s.isShowMobileMenu;
  },
  [rootypes.loadingStatusShow](s) {
    s.pageLoadingStatus = true;
  },
  [rootypes.loadingStatusHide](s) {
    s.pageLoadingStatus = false;
  },
};



// WEBPACK FOOTER //
// ./src/store/root.js